/**
 * The name customers see on Defera's flight early warnings
 * (server/flight-foresight.js): the "likely to leave late" read from the
 * plane coming in, and connection alerts. One name everywhere: the email
 * eyebrow, the text's sender line, the trip page, the Home card and the AI
 * concierge's knowledge base. Not "Foresight": that is the flight-tracking
 * supplier's own product name, and the supplier is never named to customers.
 */
export const FLIGHT_PREDICTIONS_BRAND = 'Defera Predictions';
